module.exports = __webpack_public_path__ + "static/media/S (19).40a8962e.jpg";